import { cn } from "@istari-frontend/shared";
import { CommandGroup, CommandItem } from "@istari-frontend/ui";
import { Check } from "lucide-react";

import { ControlTagSummary } from "~/control-tags/model/control-tag";
import { ControlTagChip } from "~/control-tags/ui/control-tag-chip";

export function ControlTagCommandOptions({
  tags,
  selectedIds,
  onToggle,
  disabled,
}: {
  tags: ControlTagSummary[];
  selectedIds: string[];
  onToggle: (tag: ControlTagSummary) => void;
  disabled?: boolean;
}) {
  return (
    <CommandGroup>
      {tags.map((tag) => {
        const selected = selectedIds.includes(tag.id);
        return (
          <CommandItem
            key={tag.id}
            value={`${tag.id}-${tag.name}`}
            disabled={disabled}
            onSelect={() => onToggle(tag)}
            className="flex items-center gap-2"
          >
            <span
              className={cn(
                "flex size-4 shrink-0 items-center justify-center rounded-sm border",
                selected ? "border-foreground bg-foreground text-background" : "border-input",
              )}
            >
              {selected ? <Check className="size-3" /> : null}
            </span>
            <ControlTagChip tag={tag} />
          </CommandItem>
        );
      })}
    </CommandGroup>
  );
}
